//★★暫定 2024/9/2 固まったらFrontend登録する
export const basicSettings = {
  indexAppCd: 'maintenace-ui',
  frontendCd: 'basicSettings',
  items: {
    layout: {
      header: {
        label: '',
      },
      menu: [
        {
          path: 'settings',
          title: '設定',
          children: [
            {
              path: 'settings/create-library',
              title: 'HUB・WBS・紐づけレイアウト作成',
            },
            {
              title: 'API設定',
              path: 'settings/api',
            },
          ],
        },
        {
          path: 'views',
          title: 'データ参照',
          children: [
            {
              path: 'views/action-transaction',
              title: 'アクショントランザクション',
            },
          ],
        },
      ],
    },
    actionTransactions: {
      enable: false,
      apiInfo: '',
    },
  },
};
